const COGNITO = Object.freeze({
  loggedIn: 'LOGGED_IN',
  loggedOut: 'LOGGED_OUT',
});

export default COGNITO;
